module.exports = __webpack_public_path__ + "static/media/arrow_red.d49ffa45.svg";